import { ReceiptRecoveryCase } from 'src/models/transaction.models'

interface ReceiptRecoveryProvenance {
  description: string
  label: string
}

export const getReceiptRecoveryProvenance = (
  recoveredFrom: ReceiptRecoveryCase['recoveredFrom'],
): ReceiptRecoveryProvenance => {
  switch (recoveredFrom) {
    case 'GMAIL':
      return {
        label: 'Found through Gmail',
        description:
          'The Receipt Agent recovered a receipt for this charge from the organization’s Google Workspace mailbox and believes it matches. It cannot confirm the match on its own — a person has to check the document against this charge.',
      }
    case 'GOOGLE_DRIVE':
      return {
        label: 'Found through Google Drive',
        description:
          'The Receipt Agent recovered a receipt for this charge from the organization’s Google Drive and believes it matches. It cannot confirm the match on its own — a person has to check the document against this charge.',
      }
    default:
      return {
        label: 'Recovered by Receipt Agent',
        description:
          'The Receipt Agent recovered a receipt for this charge from a connected source and believes it matches. It cannot confirm the match on its own — a person has to check the document against this charge.',
      }
  }
}
